import React from 'react'
import PropTypes from 'prop-types'

export default function CartSteps ({ children }) {
    return (
        <ul className={'mtt-cart-steps'}>
            { children }
        </ul>
    )
}

CartSteps.propTypes = {
}